import client from '../../api/client';
import type { ChecklistStatus } from './checklistApi';

export type PartnerProfile = {
  id: number;
  name: string;
  company_name: string | null;
  company_registration_number: string | null;
  vat_number: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  address: string | null;
  city: string | null;
  postal_code: string | null;
  country_code: string | null;
  status: string | null;
  partner_conditions_status: ChecklistStatus | null;
  partner_conditions_accepted_at: string | null;
  partner_agreement_status: ChecklistStatus | null;
  partner_agreement_completed_at: string | null;
  zoho_sign_url: string | null;
};

export type PartnerDetailsInput = {
  name: string;
  company_name: string;
  company_registration_number: string;
  vat_number?: string;
  contact_email: string;
  contact_phone?: string;
  address?: string;
  city?: string;
  postal_code?: string;
  country_code?: string;
  conditions_accepted?: boolean;
};

export async function fetchMyPartner() {
  const res = await client.get('/partner-onboarding/me');
  return (res.data?.distributor || null) as PartnerProfile | null;
}

export async function savePartnerDetails(body: PartnerDetailsInput) {
  const res = await client.post('/partner-onboarding/details', body);
  return res.data?.distributor as PartnerProfile;
}

export async function acceptPartnerConditions() {
  const res = await client.post('/partner-onboarding/conditions/accept');
  return res.data?.distributor as PartnerProfile;
}

export async function startPartnerAgreement() {
  const res = await client.post('/partner-onboarding/agreement');
  return {
    distributor: res.data?.distributor as PartnerProfile,
    signUrl: res.data?.sign_url as string,
  };
}
